export var text = function text(_text) {
  return {
    type: 'text',
    text: _text
  };
};